export enum VendorMatchingStatus {
    NOT_PROCESSED = "0",
    IN_PROCESSES = "1",
    COMPLETED = "2",
    FAILED = "3",
}
